export default __webpack_public_path__ + "static/media/493.9a6cf95f.jpg";